"use strict";

require("../../../header/src/style/header_widget.scss");